import { D2CSiteContentSlot } from '../../../enums/d2c-site-content/d2c-site-content-slot.enum';
import { D2CSiteBusinessProfile } from './d2c-site-business-profile';
import { D2CSiteContactProfile } from './d2c-site-contact-profile';
import { D2CSiteImageList } from './d2c-site-image-list';
// The class whose validators define each slot's allowed fields.
export const D2C_SITE_CONTENT_VALUE_CLASS = {
    [D2CSiteContentSlot.BUSINESS_PROFILE]: D2CSiteBusinessProfile,
    [D2CSiteContentSlot.CONTACT_PROFILE]: D2CSiteContactProfile,
    [D2CSiteContentSlot.HOME_HERO]: D2CSiteImageList,
    [D2CSiteContentSlot.HOME_BANNERS]: D2CSiteImageList,
    [D2CSiteContentSlot.HOME_POPUP]: D2CSiteImageList,
};
